import { render } from "./TaxDetail.vue?vue&type=template&id=44aa74b1"
import script from "./TaxDetail.vue?vue&type=script&lang=js"
export * from "./TaxDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__